import { ActivityState } from "@axio/graphql/generated/graphql";
import Pill from "../../common/Pill/Pill";

const ACTIVITY_STATE_PILL_CONFIG: Record<
  ActivityState,
  {
    label: string;
    backgroundColor: string;
    textColor: string;
  }
> = {
  [ActivityState.Draft]: {
    label: "Draft",
    backgroundColor: "#F2F4F7",
    textColor: "#667085",
  },
  [ActivityState.Scheduled]: {
    label: "Scheduled",
    backgroundColor: "#FFFAEB",
    textColor: "#B54708",
  },
  [ActivityState.Published]: {
    label: "Published",
    backgroundColor: "#ECFDF3",
    textColor: "#027A48",
  },
};

const ActivityStatePill = ({ activityState }) => {
  const activityStateConfig = activityState ? ACTIVITY_STATE_PILL_CONFIG[activityState] : null;

  if (!activityStateConfig) return null;

  return (
    <Pill
      text={activityStateConfig.label}
      textColor={activityStateConfig.textColor}
      backgroundColor={activityStateConfig.backgroundColor}
      accessibilityLabel={`Status: ${activityStateConfig.label}`}
      accessibilityRole="text"
    />
  );
};

export default ActivityStatePill;
